import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const devFirebaseConfig = {
  apiKey: "AIzaSyCua_PV2ZuvqKewkDh7xS185Llj4PxIEzo",
  authDomain: "medlyves-vietnam-doctor.firebaseapp.com",
  databaseURL: "https://medlyves-vietnam-doctor-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "medlyves-vietnam-doctor",
  storageBucket: "medlyves-vietnam-doctor.firebasestorage.app",
  messagingSenderId: "422038487362",
  appId: "1:422038487362:web:f46e9cce747b4dfc3048db",
  measurementId: "G-DCYNCZ16PS"
};

const prodFirebaseConfig = {
  apiKey: "AIzaSyDV_SBEeGfInI_qcEgWbH7UYdnx1pecbic",
  authDomain: "medlyves-doctor.firebaseapp.com",
  databaseURL: "https://medlyves-doctor-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "medlyves-doctor",
  storageBucket: "medlyves-doctor.firebasestorage.app",
  messagingSenderId: "1091315824870",
  appId: "1:1091315824870:web:f8159f9f5257b230f2a327",
  measurementId: "G-VRFLFGCEB2"
};

const dbFirebaseConfig = {
  apiKey: "AIzaSyCzlt14FpenvHM71fE3VYXEqKxS-SaTvP4",
  authDomain: "medlyves-vietnam.firebaseapp.com",
  databaseURL: "https://medlyves-vietnam-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "medlyves-vietnam",
  storageBucket: "medlyves-vietnam.firebasestorage.app",
  messagingSenderId: "798897569006",
  appId: "1:798897569006:web:78e99a19cad01b17d2c7ff",
  measurementId: "G-ZNC3X4KDKR"
};
const env = process.env.REACT_APP_ENV;
const app = initializeApp(
  devFirebaseConfig
);
const db = initializeApp(dbFirebaseConfig, "RTDB")
const auth = getAuth(app);
const database = getDatabase(db)
export { database };
export default auth;